import { type Carrier } from '../domain/Carrier'
import { type Shipper } from '../domain/Shipper'
import { type SpotQuoteListLanes } from '../domain/SpotQuoteListLanes'
import { type SpotQuoteType } from '../domain/SpotQuoteType'

export type SpotQuoteListItem = {
  carrier: Carrier
  shipper: Shipper
  type: SpotQuoteType
  lanes: SpotQuoteListLanes
  isUnderNegotiation: boolean
}

export function isSingleQuote({ type }: SpotQuoteListItem) {
  return type === 'single'
}
